import React from 'react'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'

import OfferPrice from '../../views/groupsAndOffers/complete-sessions/OfferPrice'
import {success} from '../colors'
import {BoldSpan} from '../styled-components/typography'

export interface AddedToCartBannerProps {
    participantName: string
    planName: string
    price: number
    tax?: number | null
    isTaxIncluded?: boolean | null
}

const AddedToCartBanner: React.FC<AddedToCartBannerProps> = ({
    participantName,
    planName,
    price,
    tax = null,
    isTaxIncluded = null,
}) => {
    const {t} = useTranslation()

    return (
        <Banner role="status">
            <Label>{t('offers.addedToCartConfirmation')}</Label>
            <Details>
                <BoldSpan>{participantName}</BoldSpan>
                <Separator>&middot;</Separator>
                <span>{planName}</span>
                <PriceWrapper>
                    <OfferPrice
                        price={price}
                        tax={tax}
                        isTaxIncluded={isTaxIncluded}
                        withStyle={false}
                    />
                </PriceWrapper>
            </Details>
        </Banner>
    )
}

const Banner = styled.div`
    width: 100%;
    padding: 12px 16px;
    margin-bottom: 16px;
    border-radius: 6px;
    border-left: 4px solid ${success};
    background-color: rgba(68, 157, 67, 0.1);
`

const Label = styled.div`
    color: ${success};
    font-weight: bold;
    margin-bottom: 4px;
`

const Details = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`

const Separator = styled.span`
    margin: 0 8px;
`

const PriceWrapper = styled.span`
    margin-left: 8px;
`

export default AddedToCartBanner
